import {Popconfirm} from "antd";
import React from "react";
import {Trans} from "@lingui/react/macro";


export function getSubmitCardActions({item,form,modalLink,actionSheetManager,functions})
{
    const row=item

    let MENU=[]

    if(!item?.id || !form?.id){
        return MENU
    }

    if (form?.withPaiement)
    {
        MENU.push({
            icon:"link",
            text:(<Trans>Récupérer le Lien</Trans>),
            onClick:()=>{
                modalLink.setOptions({forceDevise:row.devise}).setObject(row).getLink("PAIEMENT", {
                    type: "FORM",
                    typeId: row.id,
                    devise:row.devise
                })
            }
        })

        MENU.push({
            icon:"forward",
            warning:true,
            text:(<Trans>Renvoyer le lien de paiement</Trans>),
            onClick:()=>{
                functions.onResend(row.id)
            }
        })
    }

    if (row.state !== "VALIDE")
    {
        MENU.push({
            icon:"file-check-2",
            success:true,
            text:(<Trans>Valider la soumission</Trans>),
            onClick:()=>{
                actionSheetManager.confirm((<Trans>Êtes-vous sûrs de vouloir valider cette soumission ?</Trans>),()=>{
                    functions.onValidate(row.id)
                })
            }
        })
    }

    if (row.state !== "INVALIDE")
    {
        MENU.push({
            icon:"file-x-2",
            danger:true,
            text:(<Trans>Invalider la soumission</Trans>),
            onClick:()=>{
                actionSheetManager.confirm((<Trans>Êtes-vous sûrs de vouloir invalider cette soumission ?</Trans>),()=>{
                    functions.onInvalidate(row.id)
                })
            }
        })
    }




    if (row.archived) {

        MENU.push({
            icon:"archive-restore",
            color:"cyan",
            text:(<Trans>Désarchiver la soumission</Trans>),
            onClick:()=>{
                actionSheetManager.confirm((<Trans>Êtes-vous sûrs de vouloir désarchiver cette soumission ?</Trans>),()=>{
                    functions.onUnarchive(row.id)
                })
            }
        })
    }else
    {
        MENU.push({
            icon:"archive",
            color:"cyan",
            text:(<Trans>Archiver la soumission</Trans>),
            onClick:()=>{
                actionSheetManager.confirm((<Trans>Êtes-vous sûrs de vouloir archiver cette soumission ?</Trans>),()=>{
                    functions.onArchive(row.id)
                })
            }
        })
    }


    return MENU
}